import * as yup from 'yup';

import i18n from '../../../app/i18n';
import {
  MULTIPLE_CHOICE,
  QA,
  QUIZ,
  DESCRIPTION_LIMIT,
  TRUE_FALSE,
} from './constants';
import { sanitizedDescription } from './helpers';

export const tileSchema = yup.object().shape({
  headline: yup
    .string()
    .required(i18n.t('tileForm:validation.headlineRequired')),
  supportingContent: yup
    .string()
    .transform(value => sanitizedDescription(value))
    .max(
      DESCRIPTION_LIMIT,
      i18n.t('tileForm:validation.supportingContentLength'),
    ),
  correctAnswerIndex: yup
    .number()
    .integer()
    .when('questionType', {
      is: QUIZ,
      then: yup
        .number()
        .moreThan(
          -1,
          i18n.t('tileForm:validation.quiz.correctAnswerIndexRequired'),
        ),
    }),
  answers: yup.array().when(['questionType', 'questionSubtype'], {
    is: (questionType, questionSubType) =>
      questionType === QUIZ &&
      (questionSubType === MULTIPLE_CHOICE || questionSubType === TRUE_FALSE),
    then: yup
      .array()
      .min(2, i18n.t('tileForm:validation.quiz.minimumAnswersCount'))
      .test('unique', i18n.t('tileForm:validation.quiz.uniqueness'), value =>
        value ? value.length === new Set(value)?.size : true,
      ),
  }),
  assigneeId: yup.string().when('questionType', {
    is: QA,
    then: yup
      .string()
      .nullable()
      .required(i18n.t('tileForm:validation.questionAnswer.assigneeId')),
  }),
});
